// extracted by mini-css-extract-plugin
export var fadeInOut = "_3n-3";
export var icon = "_3n-4";
export var savedIndicator = "_3n-2";
export var savingIndicator = "_3n-0";
export var spin = "_3n-1";